import axios from 'axios';
import { SplashApi } from '../constants/API';
import { toast } from 'react-toastify';


export const api = axios.create({
    baseURL:'https://medicalradar.es/',
});

export const apiAdmin = axios.create({
  baseURL: import.meta.env.REACT_APP_API_BASE_URL,
});


apiAdmin.interceptors.request.use(
  config => {
    try {
      const signupData = JSON.parse(localStorage.getItem('SignupData'));
      const token = signupData?.data?.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (err) {
      console.error('Error reading token from localStorage:', err);
    }
    return config;
  },
  error => Promise.reject(error)
);


apiAdmin.interceptors.response.use(
  response => {
    // Check if account is deleted
    if (response?.data?.is_deleted === true) {
      localStorage.clear();
      sessionStorage.clear();
      toast.error('Your Account is Deleted!');
      window.location.replace('/');
      return response;
    }
    // Check if user is unverified (verified === 0)
    if (response?.data?.user?.verified === 0) {
      window.location.replace('/waiting');
      return response;
    }
    // Check if response indicates unauthenticated
    if (
      response?.data?.action === "Unauthenticated request" ||
      response?.data?.error === "Unauthenticated."
    ) {
    toast.error('Session expired. Please log in again.');

  setTimeout(() => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  }, 500); // Adjust timing if needed
    }
    return response;
  },
  error => {
    if (error.response?.status === 401) {
      // Clear localStorage and sessionStorage
      localStorage.clear();
      sessionStorage.clear();
      // Redirect to login page if not already there
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);


export const getApiErrorMessage = (data, fallback) => {
  const errorField = data?.error;
  if (Array.isArray(errorField) && errorField[0]) return errorField[0];
  if (typeof errorField === 'string' && errorField) return errorField;
  // if (data?.action) return data.action;
  if (data?.action_message) return data.action_message;
  return fallback;
};

export const getSplashData = () => {
    const token = JSON.parse(localStorage.getItem('SignupData'))?.data?.token;
    return apiAdmin.get(SplashApi,{
        headers: {
          Authorization: `Bearer ${token}`, // Ensure token is passed correctly
        },
      });
};


export const syncMentorApprovalFlag = (userData) => {
  if (userData?.user_type !== "doctor") return;
  const isMentorNow = userData.mentor_profile?.status === 1;
  const alreadyShownThisLogin = localStorage.getItem("mr_mentorship_approved_shown") === "true";
  if (isMentorNow && !alreadyShownThisLogin) {
    localStorage.setItem("mr_show_mentorship_approved", "true");
    localStorage.setItem("mr_mentorship_approved_shown", "true");
  }
  localStorage.setItem("mr_is_mentor", isMentorNow ? "true" : "false");
 
  window.dispatchEvent(new Event("mrMentorStatusSynced"));
};
